export default "__VITE_ASSET__a3762cda__"